export default __webpack_public_path__ + "static/media/maximize.533e2242.svg";